import MaintenanceBanner from './Banners/MaintenanceBanner';
import SlackCommunityPopup from './SlackCommunityPopup';

const Announcements = () => (
  <>
    <MaintenanceBanner />
    <SlackCommunityPopup />
  </>
);

export default Announcements;
